import HomeHero from "views/PublicHomeHeroView";

export default function Page() {
  return (
    <>
      <HomeHero />
    </>
  );
}
